<div class="container-fluid footerlte-container" [ngClass]="rootClassName">
  <div class="d-flex align-self-stretch">
    <div class="col-7 col-md-9">
      <div class="footerlte-brandlte">
        <img fetchpriority="high" loading="lazy" [attr.alt]="frame_alt" [attr.src]="frame_src" width="117" height="24" class="footerlte-frame"/>
      </div>
    </div>
    <div class="col d-flex justify-content-between">
      @if(isWeb) {
      <span class="footerlte-text labelregularsmall" (click)="onSelect('about')"><span>About</span></span>
      }
      <span class="footerlte-text labelregularsmall" (click)="onSelect('help')"><span>Help</span></span>
      <span id="tacos" class="footerlte-text labelregularsmall" (click)="onSelect('tacos')"><span>{{terms}}</span></span>
      <span id="privacy" class="footerlte-text labelregularsmall" (click)="onSelect('privacy')"><span>{{privacy}}</span></span>
    </div>
  </div>
  <div class="footerlte-separator"></div>
  <div class="d-flex align-self-stretch">
    <div class="col-8 col-md-9">
      <span class="footerlte-text labelregularsmall">
        <span>{{copyright}}</span>
      </span>
    </div>
    <div class="col d-flex justify-content-between">
      <img
        width="24" height="24"
        fetchpriority="high" loading="lazy"
        [attr.alt]="iconsocialtwitter_alt"
        [attr.src]="iconsocialtwitter_src"
        class="footerlte-iconsocial"
      />
      <img
        width="24" height="24"
        fetchpriority="high" loading="lazy"
        [attr.alt]="iconsocialfacebook_alt"
        [attr.src]="iconsocialfacebook_src"
        class="footerlte-iconsocial"
      />
      <img
        width="24" height="24"
        fetchpriority="high" loading="lazy"
        [attr.alt]="iconsociallinkedin_alt"
        [attr.src]="iconsociallinkedin_src"
        class="footerlte-iconsocial"
      />
      @if(isWeb) {
      <span class="footerlte-text labelregularsmall">
        <span>{{lte}}</span>
      </span>
      }
    </div>
  </div>
</div>
